import type { CommentMap } from './internal';
import type { ListDefinitions } from '../../../slate-api';
import type { ImageMap } from '../../../types';
import type { UUID } from '../../../types/type-helpers';
import type { WithContext } from '../../../util';

// Causes Common Build to fail?? Bizarre. type AnchorString = `\\${UUID}\\`;
interface Signature {
  anchorString: string;
  fieldId: UUID;
}

export interface DocumentContextOptions {
  authorNames: Map<string, string>;
  commentMap: CommentMap;
  imageMap: ImageMap;
  listDefinitions: ListDefinitions;
  /** See `createDocxDocument`. Only the DocuSign envelope build sets this. */
  includeDocuSignUuidTags?: boolean;
}

export class DocumentContext {
  authorNames: Map<string, string>;
  commentMap: CommentMap;
  imageMap: ImageMap;
  includeDocuSignUuidTags: boolean;
  listDefinitions: ListDefinitions;
  signatures: Signature[] = [];
  suggestedEditId: number = 0;
  private groupIdToEditId: Map<string, number> = new Map();

  constructor({
    authorNames,
    commentMap,
    imageMap,
    includeDocuSignUuidTags = false,
    listDefinitions,
  }: DocumentContextOptions) {
    this.authorNames = authorNames;
    this.commentMap = commentMap;
    this.imageMap = imageMap;
    this.includeDocuSignUuidTags = includeDocuSignUuidTags;
    this.listDefinitions = listDefinitions;
  }

  addSignature(signature: Signature): void {
    this.signatures.push(signature);
  }

  generateEditId(groupId?: string): number {
    if (groupId) {
      const existing = this.groupIdToEditId.get(groupId);
      if (existing !== undefined) return existing;
    }

    this.suggestedEditId++;

    if (groupId) {
      this.groupIdToEditId.set(groupId, this.suggestedEditId);
    }

    return this.suggestedEditId;
  }

  getAuthorName(key: string): string {
    return this.authorNames.get(key) ?? 'Anonymous';
  }
}

export type WithDocumentContext<T> = WithContext<T, DocumentContext>;
